import createApi from 'api/createApi';
import qs from 'query-string';

export const tags = {
	notificationTemplate__list: 'mw/notificationTemplate/list',
	notificationTemplate__test: 'mw/notificationTemplate/test',
};

export const notificationTemplateApi = createApi({
	reducerPath: 'mw/notificationTemplateApi',

	endpoints: (builder) => ({
		notificationTemplateList: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/notificationTemplate/list?${qs.stringify(body)}`,
			}),
			providesTags: [tags.notificationTemplate__list],
		}),
		notificationTemplateTest: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/notificationTemplate/test',
				body,
			}),
			providesTags: [tags.notificationTemplate__test],
		}),
	}),
});

export const {
	notificationTemplateList,
	notificationTemplateTest,
} = notificationTemplateApi.endpoints;

export default notificationTemplateApi;